import LogsErrorsBlueprint from './index'

export default class AppError extends Error {
  constructor({ name = null, message = null, ...rest }) {
    super()
    let logErrorObj = new LogsErrorsBlueprint({name, message, ...rest})
    
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }
    
    logErrorObj.sendLogs({ logLevel: 'error' })

  }
}
